import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import Handler from "../../Helpers/Handler";
import { textCapitalize } from "../../Helpers/Utils";

const CustomerRegisterModal = ({ onClose, onCreated }) => {
    const modalRef = useRef(null);
    const bsModalRef = useRef(null);
    const [phone, setPhone] = useState("");
    const [otp, setOtp] = useState("");
    const [otpSent, setOtpSent] = useState(false);
    const [sending, setSending] = useState(false);
    const [verifying, setVerifying] = useState(false);

    useEffect(() => {
        const el = modalRef.current;
        if (!el || !window.bootstrap) return undefined;
        const instance = window.bootstrap.Modal.getOrCreateInstance(el);
        bsModalRef.current = instance;
        const handleHidden = () => onClose?.();
        el.addEventListener("hidden.bs.modal", handleHidden);
        instance.show();
        return () => {
            el.removeEventListener("hidden.bs.modal", handleHidden);
            instance.hide();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const sendOtp = async () => {
        if (phone.trim().length !== 10) {
            toast.error("Enter a valid 10 digit phone number");
            return;
        }
        setSending(true);
        const response = await Handler({ method: "post", url: "/admin/customer/registration/phone-otp", data: { phone: phone.trim() } });
        if (response?.success) {
            toast.success(response?.data?.message || "OTP sent");
            setOtpSent(true);
        } else {
            toast.error(textCapitalize(response?.data?.message || "Unable to send OTP"));
        }
        setSending(false);
    };

    const verifyOtp = async () => {
        if (otp.trim().length !== 6) {
            toast.error("Enter the 6 digit OTP");
            return;
        }
        setVerifying(true);
        const response = await Handler({ method: "post", url: "/admin/customer/registration/verify-otp", data: { phone: phone.trim(), otp: otp.trim() } });
        if (response?.success) {
            toast.success(response?.data?.message || "Customer created");
            onCreated?.(response?.data?.data?.customerId);
        } else {
            toast.error(textCapitalize(response?.data?.message || "Unable to verify OTP"));
        }
        setVerifying(false);
    };

    return (
        <div className="modal fade" tabIndex="-1" ref={modalRef} aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content border-0 rounded-4">
                    <div className="modal-header">
                        <h5 className="modal-title fw-semibold">New Customer</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <label className="form-label">Phone number</label>
                        <div className="input-group mb-3">
                            <input
                                type="text"
                                className="form-control"
                                value={phone}
                                onChange={(e) => setPhone(e.target.value.replace(/\D/g, "").slice(0, 10))}
                                placeholder="10 digit mobile number"
                                disabled={otpSent}
                            />
                            <button type="button" className="btn btn-primary" onClick={sendOtp} disabled={sending || otpSent}>
                                {sending ? "Sending..." : otpSent ? "Sent" : "Send OTP"}
                            </button>
                        </div>

                        {otpSent ? (
                            <>
                                <label className="form-label">Enter OTP</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={otp}
                                    onChange={(e) => setOtp(e.target.value.replace(/\D/g, "").slice(0, 6))}
                                    placeholder="6 digit code"
                                />
                                <button type="button" className="btn btn-link px-0 mt-2" onClick={() => { setOtpSent(false); setOtp(""); }}>
                                    Use a different number
                                </button>
                            </>
                        ) : ""}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-danger" data-bs-dismiss="modal">Cancel</button>
                        {otpSent ? (
                            <button type="button" className="btn btn-primary" onClick={verifyOtp} disabled={verifying}>
                                {verifying ? "Verifying..." : "Verify & create"}
                            </button>
                        ) : ""}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CustomerRegisterModal;
